export default function PageHeader({ overline, title, subtitle, accent = "neutral", actions }) {
  const bar = accent === "loan" ? "bg-[#0047AB]" : accent === "own_brand" ? "bg-[#EA580C]" : "bg-brand";
  return (
    <div className="flex items-start justify-between gap-4 mb-8">
      <div className="flex gap-4">
        <div className={`w-1 rounded-full ${bar} self-stretch`} />
        <div>
          {overline && <div className="text-[11px] uppercase tracking-widest text-zinc-500 mb-1">{overline}</div>}
          <h1 className="font-heading text-3xl tracking-tight text-zinc-900">{title}</h1>
          {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
